import I18n from 'i18n-js';
import React from 'react';
import { Text, View } from 'react-native';

const NcFileChangeTile = ({ font, C, ncFileName, style, scale, color = 'Label/Light/Tertiary', fontSize = 15 }) => {
  return (
    <View style={[{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }, style]}>
      <Text
        style={[font['Subhead 1'], { color: C(color), textAlign: 'center', fontSize: scale(fontSize), lineHeight: scale(20), fontWeight: '400' }]}
      >
        {I18n.t('Change NC File')}
      </Text>
      {ncFileName ? (
        <Text
          style={[font['Subhead 1'], { color: C(color), textAlign: 'center', fontSize: scale(fontSize), lineHeight: scale(20), fontWeight: '400' }]}
        >
          {ncFileName}
        </Text>
      ) : null}
    </View>
  );
};

export default NcFileChangeTile;
